import { useInfiniteQuery } from '@tanstack/react-query';

import envVars from '../../../constants/envVars';
import useRequest from '../../../hooks/useRequest';
import { CareHistory, CareSuccess } from '../types';
import { CARE_HISTORY_KEY, careBillingUrl } from './constants';
import useCareScope from './useCareScope';

const useCareHistory = (month: string, chargeId: number, enabled: boolean) => {
    const req = useRequest();
    const orgId = useCareScope();
    return useInfiniteQuery({
        queryKey: [CARE_HISTORY_KEY, orgId, month, chargeId],
        enabled,
        initialPageParam: null as number | null,
        queryFn: ({ pageParam }) =>
            req<CareSuccess<CareHistory>>({
                url: `${envVars.API_RTM_HOSTNAME}${careBillingUrl(`month/charges/${chargeId}/history/`)}`,
                query: {
                    month,
                    limit: 25,
                    ...(pageParam !== null && { before_event_id: pageParam })
                }
            }).then((response) => response.data),
        getNextPageParam: (last) => last.next_before_event_id ?? undefined
    });
};

export default useCareHistory;
